import { Box } from '@mui/material'
import { css } from '@emotion/react'
import { motion } from 'framer-motion'
import styled from '@emotion/styled'

export interface StylesProps {
  isOpen: boolean
  isSelected?: boolean
}

export const Drawer = styled(Box)<StylesProps>`
  ${({ theme, isOpen }) => css`
    width: ${isOpen ? '274px' : '110px'};
    height: 100dvh;
    margin-right: 16px;
    border: none;
    transition: width 0.3s;
    background: ${theme.colors.myapps.blue[800]};
    box-shadow: 8px 8px 10px 0 ${theme.colors.shadows.sideBar};
    z-index: 1200;
    position: relative;

    @media (max-width: ${theme.screenSizes.laptop}) {
      position: fixed;
      width: ${isOpen ? '100%' : '0px'};
      border-radius: 0;
      overflow: hidden;
    }
  `}
`

export const SodexoLogo = styled.img`
  height: 40px;
`

export const OpenMenuButton = styled(Box)`
  ${({ theme }) => css`
    position: absolute;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${theme.colors.myapps.blue[500]};
    right: -16px;
    top: 87px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      color: ${theme.colors.lightest};
    }

    &:hover {
      transition: all ease-in-out 0.3s;
      background: ${theme.colors.myapps.gray[500]};
    }
  `}
`

export const TopBox = styled(Box)`
  ${({ theme }) => css`
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 24px 0;
    border-bottom: 1px solid;
    margin: 24px 14px 0 14px;
    border-color: ${theme.colors.myapps.gray[200]};

    @media (max-width: ${theme.screenSizes.laptop}) {
      position: relative;
      justify-content: center;
    }
  `}
`

export const LogoBox = styled(motion.create(Box))`
  ${({ theme }) => css`
    color: ${theme.colors.myapps.menus.logoText};
    font-size: 18px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      justify-content: center;
      width: 100%;
    }
  `}
`

export const MenusBox = styled(Box)<Pick<StylesProps, 'isOpen'>>`
  ${({ theme, isOpen }) => css`
    height: ${isOpen ? 'calc(100dvh - 182px)' : 'calc(100dvh - 75px)'};
    display: flex;
    flex-direction: column;
    padding: 14px;
    gap: 12px;
    overflow: auto;
    padding-right: 16px;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
    }

    &:hover {
      scrollbar-width: thin;
      scrollbar-color: ${theme.colors.myapps.blue[500]} transparent;
    }
  `}
`

export const BottomBox = styled(Box)`
  ${({ theme }) => css`
    margin: 0 14px 14px 14px;
    display: flex;
    align-items: center;
    border-top: 1px solid;
    border-color: ${theme.colors.myapps.gray[200]};
  `}
`

export const ExitButton = styled(Box)<Pick<StylesProps, 'isOpen'>>`
  ${({ theme, isOpen }) => css`
    width: 100%;
    height: 48px;
    margin-top: 14px;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.32px;
    color: ${theme.colors.lightest};
    display: flex;
    align-items: center;
    gap: 4px;
    padding-left: ${isOpen ? '16px' : '30px'};
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      transition: all ease-in-out 0.3s;
      background: ${theme.colors.myapps.gray[500]};
    }

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding-left: 16px;
    }
  `}
`

export const Icon = styled(Box)<Pick<StylesProps, 'isSelected' | 'isOpen'>>`
  ${({ theme, isSelected, isOpen }) => css`
    color: ${isSelected ? theme.colors.lightest : theme.colors.lightest};

    svg {
      margin-top: 4px;
      width: ${isOpen ? '14px' : '20px'};
      height: ${isOpen ? '14px' : '20px'};
      color: ${theme.colors.lightest};
    }
  `}
`

export const MenuText = styled(motion.create(Box))`
  white-space: nowrap;
  line-height: 20px;

  svg {
    margin-top: 4px;
    width: 14px;
    height: 14px;
  }
`
